import { tv, VariantProps } from "@/utils";

export const gallery = tv({
  slots: {
    base: ["relative", "overflow-hidden", "w-full"],
    container: ["container-fluid"],
    heading: ["flex justify-between items-center", "py-3", "mb-6"],
    title: ["text-primary-500", "max-w-sm"],
    nav: ["hidden", "sm:flex gap-8 items-center", "-translate-x-3"],
    button: [
      "relative",
      "cursor-pointer",
      "w-16 h-16",
      "text-primary-500",
      "flex items-center justify-center",
      "before:absolute before:inset-0 before:m-auto",
      "before:border-2 before:border-primary-200/50",
      "before:rotate-45",
      "after:absolute after:inset-0 after:m-auto after:-z-10",
      "after:rotate-45",
      "after:bg-primary-500",
      "after:opacity-0 after:transition-opacity after:duration-300",
      "hover:after:opacity-100 hover:text-primary-100",
      "disabled:opacity-50 disabled:pointer-events-none",
    ],
    gallery: ["keen-slider", "relative z-20", "!overflow-visible"],
  },
});

export type GalleryVariantProps = VariantProps<typeof gallery>;

export type GalleryReturnVariantProps = ReturnType<typeof gallery>;
